import FJRequirementsUtil from '@src/util/FJRequirementsUtil';
import FJConfig from '../config/FJConfig';
import FJUtil from '../util/FJUtil';
const LOCAL_USER_ID = '151000';
// const UUID = '5566@qq.com';
// const UUID = '248634999@qq.com';
const UUID = 'a1525281952@gmail.com';
// const UUID = 'lijinhang1216@gmail.com';
// const UUID = 'yuhaolinerge@163.com';
// const UUID = 'chanpin9@qq.com';
class FJNetworkManager {
    constructor() {
        this._baseUrl = FJConfig.BASE_URL;
    }
    _addCSRFToken(formData) {
        if (window.csrf_token) {
            formData.append(window.csrf_token, 1);
        }
    }
    _addUUID(headers) {
        if (FJUtil.isLocalhost()) {
            headers.uuid = UUID;
        }
    }
    _addTeamIdToFormData(formData) {
        if (FJRequirementsUtil.isTeamSpace()) {
            formData.append('tid', FJRequirementsUtil.getCurrentSpaceId());
        }
    }
    addTeamIdToUrl(url) {
        if (FJRequirementsUtil.isTeamSpace()) {
            return `${url}?tid=${FJRequirementsUtil.getCurrentSpaceId()}`;
        }
        return url;
    }
    _handleResponse(response, ignoreLogin = false) {
        const { data, code } = response;
        if (code === 200) {
            return data;
        } else if (code === 214) {
            if (!ignoreLogin) {
                FJRequirementsUtil.login();
            }
            return null;
        }
    }
    fetchResource(path, type = 'json', fetchType = 'GET', accessToken) {
        const url = path;
        let options = {};
        if (accessToken) options.headers = { Authorization: `Bearer ${accessToken}` };
        return new Promise((resolve, reject) => {
            fetch(url, { ...options, method: fetchType })
                .then(response => {
                    switch (type) {
                        case 'json':
                            return response.json();
                        case 'text':
                            return response.text();
                        case 'blob':
                            return response.blob();
                        default:
                            return response.json();
                    }
                })
                .then(resolve)
                .catch(reject);
        });
    }
    fetchBlob(path, accessToken, onProgress, signal) {
        const url = path;
        let options = { signal };
        if (accessToken) options.headers = { Authorization: `Bearer ${accessToken}` };

        return fetch(url, { ...options, method: 'GET' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const contentLength = response.headers.get('Content-Length');
                const total = parseInt(contentLength, 10);
                let loaded = 0;

                if (!response.body) {
                    throw new Error('ReadableStream not yet supported in this browser.');
                }

                const reader = response.body.getReader();
                const stream = new ReadableStream({
                    start(controller) {
                        function push() {
                            reader
                                .read()
                                .then(({ done, value }) => {
                                    if (done) {
                                        controller.close();
                                        return;
                                    }
                                    loaded += value.length;
                                    if (onProgress && total) {
                                        onProgress({ loaded, total });
                                    }
                                    controller.enqueue(value);
                                    push();
                                })
                                .catch(error => {
                                    console.error('Error in stream read:', error);
                                    controller.error(error);
                                });
                        }
                        push();
                    },
                });

                return new Response(stream);
            })
            .then(response => {
                return response.blob();
            });
    }
    async checkIsLogin() {
        let url = this._baseUrl + 'user/checkState';
        url = this.addTeamIdToUrl(url);
        const res = await fetch(url, {
            method: 'GET',
        });
        const { data, code } = await res.json();
        return data?.result && code == 200;
    }
    /**
     * @description 返回语音服务token
     * @returns {Promise<*>}
     */
    async getVoiceServiceToken() {
        let url = this._baseUrl + 'ai/get-audio-token';
        url = this.addTeamIdToUrl(url);
        const formData = new FormData();
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }
        this._addCSRFToken(formData);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data } = await res.json();
        const { token } = data;
        return token;
    }
    async createGeneratingTask(request) {
        const { type = 'ai-long-to-short', params } = request;
        const url = this._baseUrl + 'v1/ai/ai-generate';
        const formData = new FormData();
        formData.append('type', type);
        formData.append('params', JSON.stringify(params));
        let headers = {};
        this._addUUID(headers);
        this._addTeamIdToFormData(formData);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
            headers: headers,
        });
        const { data, code } = await res.json();
        return { data, code };
    }
    /**
     * 获取任务状态
     * @param {} eventId
     * @returns
     */
    async getNewTaskState(eventId) {
        const url = this._baseUrl + 'v1/ai/get-state';
        const formData = new FormData();
        formData.append('event_id', eventId);
        let headers = {};
        this._addUUID(headers);
        this._addTeamIdToFormData(formData);
        try {
            const res = await fetch(url, {
                method: 'POST',
                body: formData,
                headers: headers,
            });
            const response = await res.json();
            return this._handleResponse(response);
        } catch (error) {
            console.error(error);
            return null;
        }
    }
    async aiGenerateRetry(request) {
        const { eventId, params } = request;
        const url = this._baseUrl + 'v1/ai/ai-generate-retry';
        const formData = new FormData();
        formData.append('event_id', eventId);
        params && formData.append('params', JSON.stringify(params));
        let headers = {};
        this._addUUID(headers);
        this._addTeamIdToFormData(formData);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
            headers: headers,
        });
        const response = await res.json();
        return this._handleResponse(response);
    }
    async deleteSmartCutTasks(ids) {
        const url = this._baseUrl + 'v1/ai/delete-smart-cut-task';
        const formData = new FormData();
        formData.append('ids', ids.join(','));
        let headers = {};
        this._addUUID(headers);
        this._addTeamIdToFormData(formData);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
            headers: headers,
        });
        const { data, code } = await res.json();
        return { data, code };
    }
    async deleteSmartCutSubTasks(eventId, ids) {
        const url = this._baseUrl + 'v1/ai/delete-smart-cut-sub-task';
        const formData = new FormData();
        formData.append('event_id', eventId);
        formData.append('sub_id', ids.join(','));
        let headers = {};
        this._addUUID(headers);
        this._addTeamIdToFormData(formData);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
            headers: headers,
        });
        const { data, code } = await res.json();
        return { data, code };
    }
    /**
     * @param {{ offset?: number, limit: number }} params — offset 与后端约定从 1 开始
     */
    async getTaskList({ offset = 1, limit } = {}) {
        const url = this._baseUrl + 'v1/ai/get-task-list';
        const formData = new FormData();
        formData.append('event_type', FJConfig.JOB_TYPE);
        formData.append('offset', String(offset));
        formData.append('limit', String(limit));
        let headers = {};
        this._addUUID(headers);
        this._addTeamIdToFormData(formData);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
            headers: headers,
        });
        const response = await res.json();
        return this._handleResponse(response, true);
    }
    async updateTaskStatus(request) {
        const { eventId, name, subParams = '', status = '' } = request;
        const url = this._baseUrl + 'v1/ai/update-task';
        const formData = new FormData();
        formData.append('event_id', eventId);
        name && formData.append('name', name);
        status && formData.append('status', status);
        subParams && formData.append('sub_params', JSON.stringify(subParams));
        let headers = {};
        this._addUUID(headers);
        this._addTeamIdToFormData(formData);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
            headers: headers,
        });
        const response = await res.json();
        return this._handleResponse(response);
    }
    /**
     * @description 返回积分额度
     * @returns {Promise<{[p: string]: *}>}
     */
    async getCreditsInfo() {
        let url = this._baseUrl + 'user/get-credit-info';
        url = this.addTeamIdToUrl(url);
        let headers = {};
        this._addUUID(headers);
        const res = await fetch(url, { method: 'GET', headers: headers });
        const response = await res.json();
        return this._handleResponse(response, true);
    }
    async getFreeTimes() {
        let url = this._baseUrl + 'v1/ai/get-free-limit';
        url = this.addTeamIdToUrl(url);
        let headers = {};
        this._addUUID(headers);
        const res = await fetch(url, { method: 'GET', headers: headers });
        const response = await res.json();
        return this._handleResponse(response, true);
    }
    async feedback(params) {
        const { eventId, subId, feedback } = params;
        let url = this._baseUrl + 'v1/ai/feedback';
        url = this.addTeamIdToUrl(url);
        const formData = new FormData();
        formData.append('event_id', eventId);
        formData.append('sub_id', subId);
        formData.append('feedback', feedback);
        let headers = {};
        this._addUUID(headers);
        this._addTeamIdToFormData(formData);
        const res = await fetch(url, { method: 'POST', headers: headers, body: formData });
        const response = await res.json();
        return this._handleResponse(response);
    }
}
const _instance = new FJNetworkManager();
export default _instance;
